import { render, staticRenderFns } from "./SendReturnForm.vue?vue&type=template&id=e2e07afc&"
import script from "./SendReturnForm.vue?vue&type=script&lang=js&"
export * from "./SendReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports